import React from 'react';
import { useLocation } from 'react-router-dom';

const GlobalBackground = React.memo(function GlobalBackground() {
  const location = useLocation();

  if (location.pathname.startsWith('/login')) {
    return null;
  }

  return (
    <>
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100dvh',
        zIndex: -3,
        pointerEvents: 'none',
        backgroundColor: 'var(--color-bg)'
      }} />

      {/* SVG Waves Background */}
      <svg 
        viewBox="0 0 1440 320" 
        preserveAspectRatio="none" 
        style={{ 
          position: 'fixed', 
          bottom: 0, 
          left: 0, 
          width: '100vw', 
          height: 'min(20vh, 250px)', 
          zIndex: -2, 
          pointerEvents: 'none',
          opacity: 0.8
        }}
      >
        <path fill="color-mix(in srgb, var(--color-primary) 15%, transparent)" d="M0,224L48,213.3C96,203,192,181,288,186.7C384,192,480,224,576,234.7C672,245,768,235,864,202.7C960,171,1056,117,1152,106.7C1248,96,1344,128,1392,144L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
        <path fill="color-mix(in srgb, var(--color-primary) 25%, transparent)" d="M0,96L48,112C96,128,192,160,288,181.3C384,203,480,213,576,202.7C672,192,768,160,864,138.7C960,117,1056,107,1152,117.3C1248,128,1344,160,1392,176L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
        <path fill="color-mix(in srgb, var(--color-primary) 40%, transparent)" d="M0,288L48,272C96,256,192,224,288,197.3C384,171,480,149,576,165.3C672,181,768,235,864,250.7C960,267,1056,245,1152,213.3C1248,181,1344,139,1392,117.3L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
      </svg>

      {/* Cuadrados flotantes del sidebar */}
      <div className="bg-squares-container" style={{
        position: 'fixed',
        top: 0,
        left: '16px',
        width: '261px',
        height: '100dvh',
        zIndex: -1,
        pointerEvents: 'none',
        overflow: 'hidden'
      }}>
        <style>{`
          .bg-squares { position: absolute; top: 0; left: 0; width: 100%; height: 100%; overflow: hidden; margin: 0; padding: 0; }
          .bg-squares li { 
            position: absolute; 
            display: block; 
            list-style: none; 
            background: color-mix(in srgb, var(--color-primary) 25%, transparent); 
            animation: square-anim 35s linear infinite; 
            top: -100px; 
            border-radius: 0; 
          }
          .bg-squares li:nth-child(1) { left: 15%; width: 15px; height: 15px; animation-delay: 0s; }
          .bg-squares li:nth-child(2) { left: 45%; width: 8px; height: 8px; animation-delay: 8s; animation-duration: 40s; }
          .bg-squares li:nth-child(3) { left: 75%; width: 12px; height: 12px; animation-delay: 15s; }
          .bg-squares li:nth-child(4) { left: 25%; width: 20px; height: 20px; animation-delay: 22s; animation-duration: 45s; }
          .bg-squares li:nth-child(5) { left: 85%; width: 6px; height: 6px; animation-delay: 4s; animation-duration: 50s; }
          .bg-squares li:nth-child(6) { left: 55%; width: 18px; height: 18px; animation-delay: 28s; }
          .bg-squares li:nth-child(7) { left: 10%; width: 25px; height: 25px; animation-delay: 35s; animation-duration: 42s; }
          .bg-squares li:nth-child(8) { left: 65%; width: 10px; height: 10px; animation-delay: 11s; animation-duration: 38s; }
          
          @keyframes square-anim {
            0% { transform: translateY(0); opacity: 1; }
            100% { transform: translateY(1200px); opacity: 0; }
          }
          
          @media (max-width: 768px) {
            .bg-squares-container {
              display: none !important;
            }
          }
        `}</style>
        <ul className="bg-squares">
          <li></li><li></li><li></li><li></li>
          <li></li><li></li><li></li><li></li>
        </ul>
      </div>
    </>
  );
});

export default GlobalBackground;
